import React from 'react';
import type { ItemOrderProps } from "../../types";
import { Text, View } from '../../Components/Themed';


type OrderSummaryCardProps = {
    item_order:ItemOrderProps
}

const OrderSummaryCard = ({ item_order }:OrderSummaryCardProps) => {

    return (
        <View>
            <View style={{ flexDirection:'row', padding:5, paddingRight:10, paddingLeft:10 }}>
                <Text style={{ flex:1 }} size={14} theme='description'>Subtotal</Text>
                <Text size={14} theme='description'>${Number(item_order.amount).toFixed(2)}</Text>
            </View>
            {item_order.fee_1 ?
            <View style={{ flexDirection:'row', padding:5, paddingRight:10, paddingLeft:10 }}>
                <Text style={{ flex:1 }} size={14} theme='description'>{item_order.fee_1}</Text>
                <Text size={14} theme='description'>${item_order.fee_1_amount?.toFixed(2)}</Text>
            </View>
            :<></>}
            {item_order.fee_2 ?
            <View style={{ flexDirection:'row', padding:5, paddingRight:10, paddingLeft:10 }}>
                <Text style={{ flex:1 }} size={14} theme='description'>{item_order.fee_2}</Text>
                <Text size={14} theme='description'>${item_order.fee_2_amount?.toFixed(2)}</Text>
            </View>
            :<></>}
            <View style={{ flexDirection:'row', padding:5, paddingRight:10, paddingLeft:10 }}>
                <Text style={{ flex:1 }} size={14} theme='h1'>Total</Text>
                <Text size={14} theme='h1'>${item_order.total_amount.toFixed(2)}</Text>
            </View>
        </View>
    )
}

export default OrderSummaryCard